/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamStatistic
 */
export interface TeamStatistic {
    /**
     * 
     * @type {string}
     * @memberof TeamStatistic
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamStatistic
     */
    teamName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamStatistic
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamStatistic
     */
    categoryName?: string;
    /**
     * 
     * @type {number}
     * @memberof TeamStatistic
     */
    matchesPlayed?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamStatistic
     */
    wins?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamStatistic
     */
    draws?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamStatistic
     */
    losses?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamStatistic
     */
    goalsFor?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamStatistic
     */
    goalsAgainst?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamStatistic
     */
    goalDifference?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamStatistic
     */
    points?: number;
}

/**
 * Check if a given object implements the TeamStatistic interface.
 */
export function instanceOfTeamStatistic(value: object): value is TeamStatistic {
    return true;
}

export function TeamStatisticFromJSON(json: any): TeamStatistic {
    return TeamStatisticFromJSONTyped(json, false);
}

export function TeamStatisticFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamStatistic {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
        'matchesPlayed': json['matchesPlayed'] == null ? undefined : json['matchesPlayed'],
        'wins': json['wins'] == null ? undefined : json['wins'],
        'draws': json['draws'] == null ? undefined : json['draws'],
        'losses': json['losses'] == null ? undefined : json['losses'],
        'goalsFor': json['goalsFor'] == null ? undefined : json['goalsFor'],
        'goalsAgainst': json['goalsAgainst'] == null ? undefined : json['goalsAgainst'],
        'goalDifference': json['goalDifference'] == null ? undefined : json['goalDifference'],
        'points': json['points'] == null ? undefined : json['points'],
    };
}

export function TeamStatisticToJSON(json: any): TeamStatistic {
    return TeamStatisticToJSONTyped(json, false);
}

export function TeamStatisticToJSONTyped(value?: TeamStatistic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamId': value['teamId'],
        'teamName': value['teamName'],
        'categoryId': value['categoryId'],
        'categoryName': value['categoryName'],
        'matchesPlayed': value['matchesPlayed'],
        'wins': value['wins'],
        'draws': value['draws'],
        'losses': value['losses'],
        'goalsFor': value['goalsFor'],
        'goalsAgainst': value['goalsAgainst'],
        'goalDifference': value['goalDifference'],
        'points': value['points'],
    };
}

